import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import AccountantInvoicesAdditionArea from '../../../components/addInvoice'
import './style.scss'
const AddAccountantInvoicePage = () => {

    return (
        <Fragment>
            
           <AccountantInvoicesAdditionArea
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default AddAccountantInvoicePage
/* AddAccountantInvoicePage */